import numeral from 'numeral'
import React, { ComponentType, useState } from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'
import { Button } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-top: 32px;
`


const Text = styled.div`
  padding-bottom: 40px;
  line-height: 28px;

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

interface Props {
  property: any
}

export const Description: ComponentType<Props> = ({ property }) => {
  return (
    <Wrapper>
      <Text dangerouslySetInnerHTML={{ __html: property.description }} className="" />
    </Wrapper>
  )
}
